import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getUserInformation, logoutUser } from '@/api/user'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    userInfo: {},
  },
  mutations: {
    setToken(state, token) {
      setToken(token)
      state.token = token
    },
    setUserInfo(state, data) {
      localStorage.setItem('ddtdmxMalluser', JSON.stringify(data))
      state.userInfo = JSON.parse(JSON.stringify(data))
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInformation().then((res) => {
          if (res && res.code === 0) {
            commit('setUserInfo', res.data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(() => {
          removeToken()
          location.reload()
          reject()
        })
      })
    },
    resetUserInfo() {
      removeToken()
      localStorage.removeItem('ddtdmxMalluser')
      location.reload()
    },
    signOut() {
      logoutUser().then((res) => {
        if (res && res.code === 0) {
          removeToken()
          localStorage.removeItem('ddtdmxMalluser')
          location.reload()
        }
      })
    }
  }
})

